export default __webpack_public_path__ + "static/media/1.156d2772.jpg";